{
  "identities.messages.1010001": "로그인",
  "identities.messages.1010002": "{provider}로 로그인",
  "identities.messages.1010003": "이 작업을 확인하려면 자신임을 확인하세요.",
  "identities.messages.1010004": "두 번째 인증 도전을 완료하세요.",
  "identities.messages.1010005": "확인",
  "identities.messages.1010006": "인증 코드",
  "identities.messages.1010007": "백업 복구 코드",
  "identities.messages.1010008": "하드웨어 키로 계속하기",
  "identities.messages.1010009": "계속하기",
  "identities.messages.1010010": "계속하기",
  "identities.messages.1010011": "하드웨어 키로 로그인",
  "identities.messages.1010012": "WebAuthn 장치(예: 보안 키, 생체 인식 스캐너 등)를 준비하고 계속을 누르세요.",
  "identities.messages.1010013": "계속하기",
  "identities.messages.1010014": "귀하가 제공한 주소로 코드가 전송되었습니다. 받지 못하셨다면 주소의 철자를 확인하고 다시 시도하세요.",
  "identities.messages.1010015": "로그인 코드 전송",
  "identities.messages.1010016": "\"{duplicateIdentifier}\"로 로그인하려 했지만, 해당 이메일은 이미 다른 계정에서 사용 중입니다. 아래 옵션 중 하나로 계정에 로그인하여 \"{provider}\"에서 \"{duplicateIdentifier}\" 계정을 다른 로그인 방법으로 연결하세요.",
  "identities.messages.1010017": "로그인 및 연결",
  "identities.messages.1010018": "{provider}로 확인",
  "identities.messages.1010019": "계속하려면 코드 요청",
  "identities.messages.1010021": "패스키로 로그인",
  "identities.messages.1010022": "비밀번호로 로그인",
  "identities.messages.1010023": "{address}로 코드 전송",
  "identities.messages.1040001": "계정 생성",
  "identities.messages.1040002": "{provider}로 계정 생성",
  "identities.messages.1040003": "계속하기",
  "identities.messages.1040004": "보안 키로 계정 생성",
  "identities.messages.1040005": "귀하가 제공한 주소로 코드가 전송되었습니다. 메시지를 받지 못하셨다면 주소의 철자를 확인하고 등록을 다시 시도하세요.",
  "identities.messages.1040006": "가입 코드 전송",
  "identities.messages.1040007": "패스키로 가입",
  "identities.messages.1040008": "뒤로",
  "identities.messages.1040009": "자신을 인증할 자격 증명을 선택하세요.",
  "identities.messages.1050001": "변경 사항이 저장되었습니다!",
  "identities.messages.1050002": "{provider} 연결",
  "identities.messages.1050003": "{provider} 연결 해제",
  "identities.messages.1050004": "TOTP 인증 앱 연결 해제",
  "identities.messages.1050005": "인증 앱 QR 코드",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "백업 복구 코드 보기",
  "identities.messages.1050008": "활성화",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "이것이 귀하의 백업 복구 코드입니다. 안전한 장소에 보관하세요!",
  "identities.messages.1050011": "백업 복구 코드 확인",
  "identities.messages.1050012": "보안 키 추가",
  "identities.messages.1050013": "보안 키 이름",
  "identities.messages.1050014": "{used_at, date, long}에 비밀번호가 사용됨",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "이 방법 비활성화",
  "identities.messages.1050017": "인증 비밀번호",
  "identities.messages.1050018": "\"{display_name}\" 보안 키 제거",
  "identities.messages.1050019": "패스키 추가",
  "identities.messages.1050020": "\"{display_name}\" 패스키 제거",
  "identities.messages.1060001": "계정 복구에 성공했습니다. 다음 {privileged_session_expires_at_unix_until_minutes}분 이내에 비밀번호를 변경하거나 대체 로그인 방법(예: 소셜 로그인)을 설정하세요.",
  "identities.messages.1060002": "귀하가 제공한 이메일 주소로 복구 링크가 포함된 이메일이 전송되었습니다. 이메일을 받지 못하셨다면 주소의 철자를 확인하고 등록한 주소를 사용했는지 확인하세요.",
  "identities.messages.1060003": "귀하가 제공한 이메일 주소로 복구 코드가 포함된 이메일이 전송되었습니다. 이메일을 받지 못하셨다면 주소의 철자를 확인하고 등록한 주소를 사용했는지 확인하세요.",
  "identities.messages.1060004": "\"{masked_address}\"로 복구 코드가 전송되었습니다. 받지 못하셨다면 주소의 철자를 확인하고 등록한 주소를 사용했는지 확인하세요.",
  "identities.messages.1060005": "전체 복구 주소를 제공하여 계정에 접근을 복구하세요.",
  "identities.messages.1060006": "어떻게 계정을 복구하시겠습니까?",
  "identities.messages.1060007": "뒤로",
  "identities.messages.1070001": "비밀번호",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "저장",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "제출",
  "identities.messages.1070006": "코드 확인",
  "identities.messages.1070007": "이메일",
  "identities.messages.1070008": "코드 재전송",
  "identities.messages.1070009": "계속하기",
  "identities.messages.1070010": "복구 코드",
  "identities.messages.1070011": "확인 코드",
  "identities.messages.1070012": "등록 코드",
  "identities.messages.1070013": "로그인 코드",
  "identities.messages.1070014": "로그인 및 자격 증명 연결",
  "identities.messages.1070015": "계속하려면 캡차 도전을 완료하세요.",
  "identities.messages.1070016": "복구 주소",
  "identities.messages.1070017": "전화번호",
  "identities.messages.1080001": "귀하가 제공한 이메일 주소로 확인 링크가 포함된 이메일이 전송되었습니다. 이메일을 받지 못하셨다면 주소의 철자를 확인하고 등록한 주소를 사용했는지 확인하세요.",
  "identities.messages.1080002": "이메일 주소를 성공적으로 확인했습니다.",
  "identities.messages.1080003": "귀하가 제공한 이메일 주소로 확인 코드가 포함된 이메일이 전송되었습니다. 이메일을 받지 못하셨다면 주소의 철자를 확인하고 등록한 주소를 사용했는지 확인하세요.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "{property}를 입력하고 다시 시도하세요.",
  "identities.messages.4000003": "길이는 {min_length} 이상이어야 하지만, {actual_length}입니다.",
  "identities.messages.4000004": "\"{pattern}\" 패턴과 일치하지 않습니다.",
  "identities.messages.4000005": "{reason}로 인해 비밀번호를 사용할 수 없습니다.",
  "identities.messages.4000006": "제공된 자격 증명이 잘못되었습니다. 비밀번호 또는 사용자 이름, 이메일 주소, 전화번호에 오타가 없는지 확인하세요.",
  "identities.messages.4000007": "동일한 식별자(이메일, 전화번호, 사용자 이름 등)를 가진 계정이 이미 존재합니다.",
  "identities.messages.4000008": "제공된 인증 코드가 잘못되었습니다. 다시 시도하세요.",
  "identities.messages.4000009": "로그인 식별자를 찾을 수 없습니다. 설정을 잊지 않았는지 확인하세요. 서버 설정 오류일 수도 있습니다.",
  "identities.messages.4000010": "계정이 아직 활성화되지 않았습니다. 이메일 주소를 확인했는지 확인하세요?",
  "identities.messages.4000011": "TOTP 장치가 설정되어 있지 않습니다.",
  "identities.messages.4000012": "이 백업 복구 코드는 이미 사용되었습니다.",
  "identities.messages.4000013": "WebAuthn 장치가 설정되어 있지 않습니다.",
  "identities.messages.4000014": "백업 복구 코드가 설정되어 있지 않습니다.",
  "identities.messages.4000015": "이 계정이 존재하지 않거나 보안 키가 설정되어 있지 않습니다.",
  "identities.messages.4000016": "백업 복구 코드가 유효하지 않습니다.",
  "identities.messages.4000017": "길이는 {max_length} 이하이어야 하지만, {actual_length}입니다.",
  "identities.messages.4000018": "{minimum} 이상이어야 하지만, {actual}입니다.",
  "identities.messages.4000019": "{minimum}보다 커야 하지만, {actual}입니다.",
  "identities.messages.4000020": "{maximum} 이하이어야 하지만, {actual}입니다.",
  "identities.messages.4000021": "{maximum}보다 작아야 하지만, {actual}입니다.",
  "identities.messages.4000022": "{actual}은 {base}의 배수가 아닙니다.",
  "identities.messages.4000023": "최대 {max_items}개의 항목만 허용되지만, {actual_items}개가 발견되었습니다.",
  "identities.messages.4000024": "최소 {min_items}개의 항목이 필요하지만, {actual_items}개가 발견되었습니다.",
  "identities.messages.4000025": "인덱스 {index_a}와 {index_b}의 항목이 동일합니다.",
  "identities.messages.4000026": "{allowed_types_list}을(를) 기대했지만, {actual_type}을(를) 받았습니다.",
  "identities.messages.4000027": "동일한 식별자(이메일, 전화번호, 사용자 이름 등)를 가진 계정이 이미 존재합니다. 기존 계정에 로그인하여 소셜 프로필을 연결하세요.",
  "identities.messages.4000028": "{credential_identifier_hint}로 로그인하려 했지만, 이 식별자는 이미 다른 계정에서 사용 중입니다. {available_credential_types_list}을(를) 사용하여 로그인할 수 있습니다. 다음 소셜 로그인 제공자 중 하나를 사용하여 로그인할 수 있습니다: {available_oidc_providers_list}.",
  "identities.messages.4000029": "상수 {expected}와 같아야 합니다.",
  "identities.messages.4000030": "상수 실패",
  "identities.messages.4000031": "비밀번호가 식별자와 너무 유사하여 사용할 수 없습니다.",
  "identities.messages.4000032": "비밀번호는 최소 {min_length}자 이상이어야 하지만, {actual_length}자입니다.",
  "identities.messages.4000033": "비밀번호는 최대 {max_length}자 이하이어야 하지만, {actual_length}자입니다.",
  "identities.messages.4000034": "비밀번호가 데이터 유출 사례에 포함되어 더 이상 사용할 수 없습니다.",
  "identities.messages.4000035": "이 계정이 존재하지 않거나 코드로 로그인을 설정하지 않았습니다.",
  "identities.messages.4000036": "제공된 특성과 이 흐름과 이전에 연결된 특성이 일치하지 않습니다.",
  "identities.messages.4000037": "이 계정이 존재하지 않거나 로그인 방법이 설정되어 있지 않습니다.",
  "identities.messages.4000038": "캡차 확인에 실패했습니다. 다시 시도하세요.",
  "identities.messages.4010001": "연결이 끊어졌습니다. 다시 시도해 주세요.",
  "identities.messages.4010002": "귀하를 로그인할 수 있는 전략을 찾을 수 없습니다. 폼을 올바르게 작성했는지 확인하세요?",
  "identities.messages.4010003": "귀하를 등록할 수 있는 전략을 찾을 수 없습니다. 폼을 올바르게 작성했는지 확인하세요?",
  "identities.messages.4010004": "설정을 업데이트할 수 있는 전략을 찾을 수 없습니다. 폼을 올바르게 작성했는지 확인하세요?",
  "identities.messages.4010005": "계정을 복구할 수 있는 전략을 찾을 수 없습니다. 폼을 올바르게 작성했는지 확인하세요?",
  "identities.messages.4010006": "계정을 확인할 수 있는 전략을 찾을 수 없습니다. 폼을 올바르게 작성했는지 확인하세요?",
  "identities.messages.4010007": "요청은 이미 성공적으로 완료되었으며 다시 시도할 수 없습니다.",
  "identities.messages.4010008": "로그인 코드가 잘못되었거나 이미 사용되었습니다. 다시 시도하세요.",
  "identities.messages.4010009": "연결된 자격 증명이 일치하지 않습니다.",
  "identities.messages.4010010": "입력한 주소가 현재 계정의 알려진 주소와 일치하지 않습니다.",
  "identities.messages.4040001": "연결이 끊어졌습니다. 다시 시도해 주세요.",
  "identities.messages.4040002": "요청은 이미 성공적으로 완료되었으며 다시 시도할 수 없습니다.",
  "identities.messages.4040003": "등록 코드가 잘못되었거나 이미 사용되었습니다. 다시 시도하세요.",
  "identities.messages.4050001": "연결이 끊어졌습니다. 다시 시도해 주세요.",
  "identities.messages.4060001": "요청은 이미 성공적으로 완료되었으며 다시 시도할 수 없습니다.",
  "identities.messages.4060002": "복구 흐름이 실패 상태에 도달하여 다시 시도해야 합니다.",
  "identities.messages.4060004": "복구 토큰이 잘못되었거나 이미 사용되었습니다. 흐름을 다시 시도하세요.",
  "identities.messages.4060005": "연결이 끊어졌습니다. 다시 시도해 주세요.",
  "identities.messages.4060006": "복구 코드가 잘못되었거나 이미 사용되었습니다. 다시 시도하세요.",
  "identities.messages.4070001": "확인 토큰이 잘못되었거나 이미 사용되었습니다. 흐름을 다시 시도하세요.",
  "identities.messages.4070002": "요청은 이미 성공적으로 완료되었으며 다시 시도할 수 없습니다.",
  "identities.messages.4070003": "확인 흐름이 실패 상태에 도달하여 다시 시도해야 합니다.",
  "identities.messages.4070005": "연결이 끊어졌습니다. 다시 시도해 주세요.",
  "identities.messages.4070006": "확인 코드가 잘못되었거나 이미 사용되었습니다. 다시 시도하세요.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "로그아웃",
  "login.registration-button": "가입",
  "login.registration-label": "계정이 없으신가요?",
  "login.title": "로그인",
  "login.subtitle": "{parts}로 로그인",
  "login.title-aal2": "두 번째 인증 요소 인증",
  "login.subtitle-aal2": "두 번째 인증 요소 인증을 완료할 방법을 선택하세요",
  "login.code.subtitle": "이메일로 확인 코드가 전송됩니다",
  "login.webauthn.subtitle": "WebAuthN 장치를 준비하세요",
  "login.totp.subtitle": "인증 앱에서 생성된 코드를 입력하세요",
  "login.lookup_secret.subtitle": "8자리 백업 복구 코드 중 하나를 입력하세요",
  "login.title-refresh": "재인증",
  "login.subtitle-refresh": "{parts}로 신원을 확인하세요",
  "login.2fa.go-back": "무엇이 문제인가요?",
  "login.2fa.go-back.link": "뒤로 가기",
  "login.2fa.method.go-back": "다른 방법 선택",
  "recovery.title": "계정 복구",
  "recovery.subtitle": "계정과 연결된 식별자를 입력하여 일회용 액세스 코드를 받으세요",
  "registration.login-button": "로그인",
  "registration.login-label": "계정이 있으신가요?",
  "registration.title": "계정 등록",
  "registration.subtitle": "{parts}로 가입",
  "settings.navigation-back-button": "뒤로",
  "settings.subtitle": "계정 설정 업데이트",
  "settings.title": "계정 설정",
  "settings.password.title": "비밀번호 변경",
  "settings.password.description": "비밀번호 수정",
  "settings.profile.title": "프로필 설정",
  "settings.profile.description": "프로필 정보 업데이트",
  "settings.webauthn.title": "하드웨어 토큰 관리",
  "settings.webauthn.description": "하드웨어 토큰 설정 관리",
  "settings.messages.toast-title.success": "설정 업데이트됨",
  "settings.messages.toast-title.error": "설정을 업데이트할 수 없음",
  "verification.title": "계정 확인",
  "verification.subtitle": "계정과 연결된 이메일 주소를 입력하여 확인하세요",
  "two-step.password.title": "비밀번호",
  "two-step.password.description": "계정과 연결된 비밀번호를 입력하세요",
  "two-step.code.title": "이메일 코드",
  "two-step.code.description": "이메일로 확인 코드가 전송됩니다",
  "two-step.webauthn.title": "보안 키",
  "two-step.webauthn.description": "보안 키를 사용하여 인증하세요",
  "two-step.passkey.title": "패스키 (권장)",
  "two-step.passkey.description": "기기의 지문 또는 얼굴 인식 기능을 사용하세요",
  "two-step.passkey.description.error": "패스키를 사용하기 위한 필요한 라이브러리를 로드할 수 없습니다. 나중에 다시 시도하세요.",
  "two-step.totp.title": "인증 앱 사용 (TOTP)",
  "two-step.totp.description": "인증 앱에서 생성된 6자리 일회용 코드를 사용하세요",
  "two-step.lookup_secret.title": "백업 복구 코드",
  "two-step.lookup_secret.description": "8자리 백업 코드 중 하나를 사용하여 인증하세요",
  "input.placeholder": "{placeholder} 입력",
  "card.header.parts.oidc": "소셜 제공자",
  "card.header.parts.password.registration": "{identifierLabel}과 비밀번호",
  "card.header.parts.password.login": "{identifierLabel}과 비밀번호",
  "card.header.parts.code": "일회용 코드",
  "card.header.parts.passkey": "패스키",
  "card.header.parts.webauthn": "보안 키",
  "card.header.parts.totp": "인증 앱",
  "card.header.parts.lookup_secret": "백업 복구 코드",
  "card.header.parts.identifier-first": "{identifierLabel}",
  "misc.or": "또는",
  "forms.label.forgot-password": "비밀번호를 잊으셨나요?",
  "forms.label.recover-account": "계정 복구",
  "settings.totp.title": "인증 앱",
  "settings.totp.description": "계정에 TOTP 인증 앱을 추가하여 계정 보안을 강화하세요. 인기 있는 인증 앱은 LastPass와 Google Authenticator입니다.",
  "settings.totp.info.not-linked": "활성화하려면 인증 앱으로 QR 코드를 스캔하고 코드를 입력하세요.",
  "settings.totp.info.linked": "현재 인증 앱이 연결되어 있습니다.",
  "settings.lookup_secret.title": "백업 복구 코드 (두 번째 인증 요소)",
  "settings.lookup_secret.description": "복구 코드는 2FA의 안전한 백업으로, 2FA 장치를 분실했을 때 계정에 다시 접근할 수 있도록 해줍니다.",
  "settings.oidc.title": "연결된 계정",
  "settings.oidc.description": "소셜 로그인 제공자와 계정을 연결하세요.",
  "settings.oidc.info": "이 제공자에서 연결된 계정은 계정에 로그인하는 데 사용할 수 있습니다.",
  "settings.webauthn.info": "하드웨어 토큰은 두 번째 인증 요소 또는 패스키와 함께 첫 번째 인증 요소로 사용됩니다.",
  "settings.passkey.title": "패스키 관리",
  "settings.passkey.description": "패스키 설정 관리",
  "settings.passkey.info": "패스키 설정 관리",
  "card.footer.select-another-method": "다른 방법 선택",
  "account-linking.title": "계정 연결",
  "property.password": "비밀번호",
  "property.email": "이메일",
  "property.phone": "전화번호",
  "property.username": "사용자 이름",
  "property.identifier": "식별자",
  "property.code": "코드",
  "property.recovery_address": "복구 주소",
  "consent.title": "{party} 승인",
  "consent.subtitle": "제3자 애플리케이션이 귀하의 계정 {identifier}와 관련된 정보에 접근하고자 합니다.",
  "consent.scope.openid.title": "신원",
  "consent.scope.openid.description": "애플리케이션이 귀하의 신원을 확인할 수 있도록 허용합니다. 이는 인증 및 신뢰할 수 있는 로그인 경험을 위해 필요합니다.",
  "consent.scope.offline_access.title": "오프라인 액세스",
  "consent.scope.offline_access.description": "이 애플리케이션이 활성적으로 사용하지 않을 때도 계속 로그인 상태를 유지할 수 있도록 허용합니다.",
  "consent.scope.profile.title": "프로필 정보",
  "consent.scope.profile.description": "기본 프로필 세부 정보(사용자 이름, 이름, 성)에 접근할 수 있도록 허용합니다.",
  "consent.scope.email.title": "이메일 주소",
  "consent.scope.email.description": "이메일 주소와 확인 상태를 조회합니다.",
  "consent.scope.address.title": "물리적 주소",
  "consent.scope.address.description": "우편 주소에 접근합니다.",
  "consent.scope.phone.title": "전화번호",
  "consent.scope.phone.description": "전화번호와 확인 상태를 조회합니다.",
  "error.title.what-happened": "무엇이 발생했나요?",
  "error.title.what-can-i-do": "무엇을 할 수 있나요?",
  "error.instructions": "몇 분 후 다시 시도하거나 웹사이트 운영자에게 문의하세요.",
  "error.footer.text": "이 오류를 보고할 때 다음 정보를 포함해 주세요:",
  "error.footer.copy": "복사",
  "error.action.go-back": "뒤로 가기",
  "identities.messages.4000039": "새 비밀번호는 이전 비밀번호와 달라야 합니다.",
  "identities.messages.4000040": "유효한 이메일 주소를 입력하세요",
  "identities.messages.4000041": "유효한 전화번호를 입력하세요",
  "captcha.error": "보안 확인에 실패했습니다. 나중에 다시 시도해 주세요. 문제가 지속되면 지원팀에 문의하세요.",
  "identities.messages.5000002": "사용 가능한 인증 방법이 없습니다. 시스템 관리자에게 문의하십시오.",
  "identities.messages.4010011": "해당 계정은 비활성화되었습니다. 문제 해결을 위해 고객 지원팀에 문의해 주시기 바랍니다.",
  "identities.messages.1070018": "이메일 주소 또는 전화번호",
  "identities.messages.1080004": "인증 코드가 포함된 문자 메시지가 귀하가 제공한 전화번호로 전송되었습니다. 문자 메시지를 받지 못하셨다면, 전화번호를 다시 확인하고 등록하신 전화번호를 사용하고 있는지 확인해 주시기 바랍니다.",
  "identities.messages.1080005": "휴대폰 번호 인증이 완료되었습니다.",
  "identities.messages.5000003": "귀사의 조직에서는 SSO(싱글 사인온) 인증이 필요하지만, 현재 SSO 제공업체가 구성되어 있지 않습니다. 시스템 관리자에게 문의해 주시기 바랍니다.",
  "identities.messages.1010024": "하드웨어 키를 사용하여 로그인하세요.",
  "identities.messages.1010025": "코드가 주소로 전송되었습니다. 받지 못하셨다면 다시 시도해 주세요.",
  "identities.messages.4000042": "디바이스 인증 장치가 설정되지 않았습니다.",
  "identities.messages.4000043": "제공된 웹 인증 로그인 정보가 유효하지 않습니다. 다시 시도해 주십시오.",
  "identities.messages.4000044": "제공된 DeviceAuthn 서명이 유효하지 않습니다.",
  "identities.messages.4050002": "한 번에 주소 하나만 변경할 수 있습니다. 각 주소를 따로 업데이트해 주세요."
}
